import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  useColorModeValue,
  Image,
  Select,
} from "@chakra-ui/react";
import Background from "assets/img/backarrow.jpg";
import Logo from "assets/img/whitelogo.png";
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { login } from '../../../state/actions/authActions';
import { changePassword, verifyOtp } from '../../../state/actions/authActions';
import { merchantLogin } from "../../../state/actions/authActions";
import { useDispatch, useSelector } from 'react-redux';
import GradientButton from "components/Buttons/GradientButton";
import { useCustomNotification } from "components/Toasts/OpenNotification";

function AuthForm({ isSignUp, isPasswordChange, isVerifyOtp }) {
  const titleColor = useColorModeValue("#071D54", "#071D54");
  const textColor = useColorModeValue("gray.400", "white");
  const { t } = useTranslation();
  const history = useHistory();
  const toastNotification = useCustomNotification();

  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);
  const { otpVerifying, otpError, otpSuccess } = useSelector((state) => state.auth);


  // Shared
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  useEffect(() => {
    if (isPasswordChange || isVerifyOtp) {
      const savedEmail = localStorage.getItem("login_email");
      if (savedEmail) setEmail(savedEmail);
    }
  }, [isPasswordChange, isVerifyOtp]);

  // For sign up
  const [userType, setUserType] = useState("Individual");
  const [username, setUsername] = useState("");
  const [phone, setPhone] = useState("");

  // For password change
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // OTP state
  const [otp, setOtp] = useState(new Array(6).fill(""));

  const handleSubmit = async (e) => {
    e.preventDefault();

    let response;

    try {
      response = await dispatch(login(email, password));
    } catch (err) { }
    console.log("LOGIN RESPONSE:", response);
    console.log("USER TYPE:", response?.user?.user_type);
    if (!response?.success && !response?.access_token) {
      try {
        response = await dispatch(merchantLogin(email, password));
      } catch (err) { }
    }
      console.log("LOGIN RESPONSE:", response);
    console.log("USER TYPE:", response?.user?.user_type);
    if (
      response?.error ===
      "Account is inactive. Please activate your account to log in."
    ) {
      localStorage.setItem("login_email", email);

      toastNotification({
        type: "warning",
        message: "Account Inactive",
        description: "Please change your password to activate your account.",
      });

      history.push("/auth/change-password");
      return;
    }

    if (response?.access_token) {
      localStorage.setItem("login_email", email);
      localStorage.setItem("access_token", response.access_token);
      localStorage.setItem("refresh_token", response.refresh_token);
      localStorage.setItem("user_id", response.user.user_id);
      localStorage.setItem("user", JSON.stringify(response.user));

      toastNotification({
        type: "info",
        message: "Login Successful",
        description: "You are now logged in.",
      });

      const userType = response.user?.user_type;

      if (userType === "Admin") {
        history.push("/admin/dashboard");
      } else if (userType === "Merchant") {
        history.push("/merchant/dashboard");
      } else {
        history.push("/auth/signin");
      }
    } else {
      toastNotification({
        type: "error",
        message: "Login Failed",
        description: response?.error || "Invalid credentials",
      });
    }
  };

  const handlePasswordChange = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      return toastNotification({
        type: "error",
        message: "Password Mismatch",
        description: "New password and confirmation do not match.",
      });
    }

    try {
      const res = await dispatch(changePassword(email, oldPassword, newPassword));
      if (res?.success) {
        toastNotification({
          type: "success",
          message: "Password Changed",
          description: "Your password was successfully updated.",
        });
        history.push("/admin/dashboard");
      } else {
        toastNotification({
          type: "error",
          message: "Change Failed",
          description: res?.error || "Failed to change password.",
        });
      }
    } catch (err) {
      console.error(err);
      toastNotification({
        type: "error",
        message: "Unexpected Error",
        description: "An error occurred while changing password.",
      });
    }
  };

  const handleOtpChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    // Auto focus next input
    const next = document.getElementById(`otp-${index + 1}`);
    if (value && next) next.focus();
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    const enteredOtp = otp.join("");
    if (enteredOtp.length < 6) {
      toastNotification({ type: "error", message: "Incomplete OTP", description: "Please enter all 6 digits." });
      return;
    }

    try {
      const user_id = localStorage.getItem("user_id");

      const response = await dispatch(verifyOtp({ user_id, otp: enteredOtp }));

      if (response?.success) {
        localStorage.setItem("otp_verified", "true");
        const userType = response?.user?.user_type;

        if (userType === "Admin") {
          localStorage.setItem("access_token", response.access_token);
          localStorage.setItem("refresh_token", response.refresh_token);

          toastNotification({
            type: "success",
            message: "OTP Verified",
            description: "Welcome back!",
          });

          history.push("/admin/dashboard");
        } else {
          toastNotification({
            type: "error",
            message: "Access Denied",
            description: "You are not authorized to access the admin panel.",
          });
        }
      } else {
        toastNotification({
          type: "error",
          message: "Verification Failed",
          description: response?.error || "OTP verification failed.",
        });
      }
    } catch (error) {
      console.error("OTP Verification Error:", error);
      toastNotification({
        type: "error",
        message: "Error",
        description: "Something went wrong while verifying OTP.",
      });
    }
  };



  return (
    <Flex position='relative' mb='40px'>
      <Flex
        h={{ sm: "initial", md: "75vh", lg: "95vh" }}
        w='100%'
        maxW='1044px'
        mx='auto'
        justifyContent='space-between'
        pt={{ sm: "100px", md: "0px" }}
      >
        <Flex alignItems='center' justifyContent='start' w={{ base: "100%", md: "50%", lg: "42%" }}>
          <Flex direction='column' w='100%' background='transparent' p='48px' mt={{ md: "150px", lg: "80px" }}>
            <Heading color={titleColor} fontSize='32px' mb='10px' textAlign={"center"}>
              {isVerifyOtp
                ? "Verify OTP"
                : isPasswordChange
                  ? "Change Password"
                  : isSignUp
                    ? "Sign Up"
                    : "Sign In"}
            </Heading>

            <FormControl
              onSubmit={
                isVerifyOtp
                  ? handleOtpSubmit
                  : isPasswordChange
                    ? handlePasswordChange
                    : handleSubmit
              }
              as="form"
            >
              {isVerifyOtp ? (
                <>
                  <Flex gap="10px" justify="center" mb="24px">
                    {otp.map((digit, index) => (
                      <Input
                        key={index}
                        id={`otp-${index}`}
                        value={digit}
                        onChange={(e) => handleOtpChange(e.target.value, index)}
                        type="text"
                        maxLength="1"
                        size="lg"
                        textAlign="center"
                        borderRadius="md"
                        width="40px"
                        fontSize="xl"
                        borderColor="gray.300"
                        padding="0"
                      />
                    ))}
                  </Flex>
                </>
              ) : isPasswordChange ? (
                <>
                  <FormLabel fontSize='sm'>Old Password</FormLabel>
                  <Input mb='24px' size='md' type='password' value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} />
                  <FormLabel fontSize='sm'>New Password</FormLabel>
                  <Input mb='24px' size='md' type='password' value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
                  <FormLabel fontSize='sm'>Confirm New Password</FormLabel>
                  <Input mb='24px' size='md' type='password' value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} />
                </>
              ) : isSignUp ? (
                <>
                  <FormLabel fontSize='sm'>User Type</FormLabel>
                  <Select mb='24px' size='lg' value={userType} onChange={(e) => setUserType(e.target.value)}>
                    <option value="Driver">Driver</option>
                    <option value="Individual">Individual</option>
                  </Select>
                  <FormLabel fontSize='sm'>Username</FormLabel>
                  <Input mb='24px' size='lg' placeholder="Your username" value={username} onChange={(e) => setUsername(e.target.value)} />
                  <FormLabel fontSize='sm'>Phone Number</FormLabel>
                  <Input mb='24px' size='lg' placeholder="Enter phone number" value={phone} onChange={(e) => setPhone(e.target.value)} />
                </>
              ) : (
                <>
                  <FormLabel fontSize='sm'>{t('email')}</FormLabel>
                  <Input mb='24px' size='md' type='text' placeholder={t('your_email')} value={email} onChange={(e) => setEmail(e.target.value)} />
                  <FormLabel fontSize='sm'>{t('password')}</FormLabel>
                  <Input mb='36px' size='md' type='password' placeholder={t('your_password')} value={password} onChange={(e) => setPassword(e.target.value)} />
                </>
              )}

              <GradientButton fontSize='12px' type='submit' width='100%' height='45px' mb='20px' mt='20px' loading={loading}>
                {isVerifyOtp
                  ? "Verify"
                  : isPasswordChange
                    ? "Update Password"
                    : isSignUp
                      ? t('sign_up')
                      : t('sign_in')}
              </GradientButton>
            </FormControl>
          </Flex>
        </Flex>

        {/* Background Image Box */}
        <Box display={{ base: "none", md: "block" }} overflowX="hidden" h="100%" w="40vw" position="absolute" right="0px">
          <Box bgImage={Background} w="100%" h="100%" bgSize="cover" bgPosition="50%" position="absolute" borderBottomLeftRadius="20px" display="flex" flexDirection="column" alignItems="center" justifyContent="center">
            <Image src={Logo} alt="Overlay Logo" mb='20px' maxHeight="230px" maxWidth="230px" />
          </Box>
        </Box>
      </Flex>
    </Flex>
  );
}

export default AuthForm;
